import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UserModuleApiSuffixModels } from '@app/modules';
import { AppState } from '@app/reducers';
import { CrudType, IApplicationResponse, LoggedInUserModel, ModulesBasedApiSuffix, SnackbarService, addDefaultTableObjectProperties, checkUserPermissionsByCategory, currentComponentPageBasedPermissionsSelector$, onActionSubmittedUtil, prepareDynamicTableTabsFromPermissions, prepareGetRequestHttpParams } from '@app/shared';
import { CrudService, RxjsService } from '@app/shared/services';
import { loggedInUserData } from '@modules/others';
import { CONFIGURATION_COMPONENT } from '@modules/others/configuration/utils/configuration-component.enum';
import { Store } from '@ngrx/store';
import { DialogService } from 'primeng/api';
import { combineLatest } from 'rxjs';
import { PrimeNgTableVariablesModel } from '../../../../../shared/models/prime-ng-table-list-component-variables.model';
@Component({
  selector: 'app-specialpermission-list',
  templateUrl: './permission-approval-list.component.html',
})
export class PermissionApprovalListComponent extends PrimeNgTableVariablesModel implements OnInit {
  primengTableConfigProperties: any = {
    tableCaption: "Leave Management Approver List",
    selectedTabIndex: 0,
    breadCrumbItems: [{ displayName: 'Configuration ', relativeRouterUrl: '' }, { displayName: 'Leave Management Approver List' }],
    tableComponentConfigs: {
      tabsList: [
        {
          caption: 'Leave Management Approver List',
          dataKey: 'specialPermissionId',
          enableGlobalSearch:true,
          columns: [{ field: 'employeeNo', header: 'Employee ID', width: '150px' },
          { field: 'resquestedBy', header: 'Requested By', width: '200px' },
          { field: 'requestTypeName', header: 'Request Type', width: '150px' },
          { field: 'leaveType', header: 'Leave Type', width: '150px' },
          { field: 'applyType', header: 'Apply Type', width: '120px' },
          { field: 'period', header: 'Period', width: '250px' },
          { field: 'nominatedTo', header: 'Approved By', width: '150px' },
          { field: 'status', header: 'Status', width: '150px' },
          ],
          apiSuffixModel: UserModuleApiSuffixModels.LEAVE_MANAGEMENT_MANAGER,
          moduleName: ModulesBasedApiSuffix.IT_MANAGEMENT
        }]
    }
  }

  constructor(private crudService: CrudService,
    private rxjsService: RxjsService,
    private router: Router,
    private store: Store<AppState>,
    private snackbarService: SnackbarService,
    public dialogService: DialogService) {
    super();
    this.primengTableConfigProperties = addDefaultTableObjectProperties(this.primengTableConfigProperties, [{ index: 0, propertyName: 'enableFieldsSearch' },
    { index: 0, propertyName: 'enableAddActionBtn' }]);
  }

  ngOnInit(): void {
    this.getDivisions();
    this.combineLatestNgrxStoreData();
  }

  combineLatestNgrxStoreData() {
    combineLatest([
      this.store.select(loggedInUserData),
      this.store.select(currentComponentPageBasedPermissionsSelector$)]
    ).subscribe((response) => {
      this.loggedInUserData = new LoggedInUserModel(response[0]);
      let permission = response[1][CONFIGURATION_COMPONENT.LEAVE_MANAGEMENT_APPROVAL]
      if (permission) {
        let prepareDynamicTableTabsFromPermissionsObj = prepareDynamicTableTabsFromPermissions(this.primengTableConfigProperties, permission);
        this.primengTableConfigProperties = prepareDynamicTableTabsFromPermissionsObj['primengTableConfigProperties'];
      }
    });
  }

  getDivisions(pageIndex?: string, pageSize?: string, otherParams?: object): void {
    this.loading = true;
    this.crudService.get(ModulesBasedApiSuffix.IT_MANAGEMENT, UserModuleApiSuffixModels.LEAVE_MANAGEMENT_MANAGER, undefined, false,
      prepareGetRequestHttpParams(pageIndex, pageSize, otherParams)).subscribe((response: IApplicationResponse) => {
        if (response.isSuccess && response.statusCode === 200 && response.resources) {
          this.dataList = response.resources
          this.dataList.map(item => {
            if (item.status == "Declined") {
              item.cssClass = "status-label-yellow";
            }
            if (item.status == "Approved") {
              item.cssClass = "status-label-green";
            }
            if (item.status == "Pending") {
              item.cssClass = "status-label-blue";
            }
          })
          this.totalRecords = response.totalCount;
          this.loading = false;
        }
        this.rxjsService.setGlobalLoaderProperty(false);
      });
  }

  onCRUDRequested(type: CrudType | string, row?: object, searchObj?): void {
    switch (type) {
      case CrudType.GET:
        switch (this.selectedTabIndex) {
          case 0:
            this.getDivisions(row["pageIndex"], row["pageSize"], searchObj);
            break;
        }
        break;
      case CrudType.VIEW:
        if (checkUserPermissionsByCategory.bind(this, CrudType.VIEW)) {
          this.router.navigate(['/user/leave-user/approval-list/approval'], { state: { id: row['specialPermissionId'] } });
        }
        break;
    }
  }

  onActionSubmited(e) {
    onActionSubmittedUtil(e, this.onCRUDRequested.bind(this));
  }

  onChangeSelecedRows(e) {
    this.selectedRows = e;
  }
}
